<template>
  <div>
    <!--Start Banner Slider--->
    <section class="section-banner simple-banner">
      <slick
        v-if="pagesList.length > 0"
        ref="banner-slider"
        :options="bannerSlider"
      >
        <div
          v-for="(data, index) in pagesList
            .flatMap((p) => p.banner)
            .flatMap((b) => b.split(','))"
          :key="index"
        >
          <div class="w-100 banner-slider">
            <div class="banner-img">
              <img v-if="data" :src="data" class="image" />
            </div>
          </div>
        </div>
      </slick>
    </section>
    <!--End Banner Slider--->
    <div class="container px-0">
      <!-- <QuickBook /> -->
    </div>
    <div class="container custom-container my-3 cinema-menus">
      <div
        class="accordion pt-3"
        v-for="(item, indexArray) in pagesList"
        :key="indexArray"
      >
        <div
          v-for="(records, recordIndex) in item.otherData"
          :key="recordIndex"
        >
          <div class="cinema-accordion offer-accordion">
            <div
              v-b-toggle="'menu' + recordIndex"
              variant="info"
              class="accordion-title"
            >
              <div class="main-heading" v-if="records.main_name">
                <div>
                  <hr class="primary-line" />
                </div>
                <div class="title">{{ records.main_name }}</div>
              </div>
            </div>
            <b-collapse :id="'menu' + recordIndex" visible>
              <div class="content mb-3">
                <div class="content-title my-3">{{ records.header_name }}</div>
                <div class="content-desc">
                  {{ records.description }}
                </div>
                <div class="offer-imgs empire-slider mx-0 mt-3" v-if="false">
                  <slick ref="food-1" :options="foodSlider1">
                    <div
                      class=""
                      v-for="(data, img_index) in records.images.split(',')"
                      :key="img_index"
                    >
                      <div
                        v-b-modal="
                          'offer-modal' + img_index + indexArray + recordIndex
                        "
                      >
                        <img
                          class="offer-img"
                          :src="checkBaseUrl(data)"
                          alt="image-1"
                        />
                      </div>

                      <!-- <img :src="URL_BASE + data" class="offer-img" /> -->
                    </div>
                  </slick>
                  <div
                    class=""
                    v-for="(data, index) in records.images.split(',')"
                    :key="index"
                  >
                    <b-modal
                      :id="'offer-modal' + index + indexArray + recordIndex"
                      hide-footer
                      size="sm"
                      class="food-modal-content"
                      :ref="'offerpopup' + index"
                    >
                      <div>
                        <img
                          class="food-popup-img"
                          :src="checkBaseUrl(data)"
                          alt="img-fluid w-100"
                        />
                      </div>
                    </b-modal>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>

    <!---Form Section Start-->
    <form @submit.prevent="formSubmit">
      <div class="d-block container mt-4">
        <!---Full Name-->
        <div class="d-flex mb-3 justify-content-center">
          <div class="col-xl-3 col-md-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[3].title }}
          </div>

          <b-form-input
            v-model="carrerDeatils.fullName"
            type="text"
            class="carrer_input"
          />
        </div>

        <!---Email-->
        <div class="d-flex mb-3 justify-content-center">
          <div class="col-xl-3 col-md-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[4].title }}
          </div>

          <b-form-input
            v-model="carrerDeatils.Email"
            type="email"
            class="carrer_input"
          />
        </div>

        <!--Mobile Number-->
        <div
          class="d-flex mb-3 justify-content-center"
          :class="
            langName == 'ar'
              ? 'carrer_mobile_ar_private'
              : 'carrer_mobile_private'
          "
        >
          <div class="col-xl-3 col-md-3 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[5].title }}
          </div>

          <vue-phone-number-input
            color="#cf1f2e"
            default-country-code="SA"
            v-model="carrerDeatils.Mobile"
            @update="onUpdate"
            :dir="langName === 'ar' ? 'rtl' : 'ltr'"
            :translations="computedTranslations"
            :no-example="true"
          />
          <!-- @update="resultsExample = $event" -->
          <!-- <span
              >{{ carrerDeatils.fullmobnumber }}
              {{ carrerDeatils.Mobile }}</span
            > -->
        </div>
        <!-- <table class="mr-2">
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
            <tr v-for="item in resultsTable" :key="item" class="w-100">
              <td>
                {{ item }}
              </td>
              <td>{{ results[item] }}</td>
            </tr>
          </table> -->

        <!-- <div class="flex flex-direction-column flex-1">
            <b>Payload:</b>
            {{ results.formatInternational }}
          </div> -->

        <!---City u live -->
        <div class="d-flex mb-3 justify-content-center">
          <div class="col-xl-3 col-md-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[10].title }}
          </div>

          <multiselect
            v-model="carrerDeatils.CityName"
            :options="langName === 'ar' ? translatedBranchName : cinema_array"
            label="cinema_name"
            track-by="cinema_id"
            class="carrer_input"
            :select-label="''"
            :deselect-label="''"
            :placeholder="langName === 'ar' ? 'اختر مدينة' : 'Select City'"
            :selectedLabel="''"
            :class="{ 'multiselect-arabic': langName === 'ar' }"
            :style="{
              textAlign: langName === 'ar' ? 'right' : 'left',
            }"
          >
          </multiselect>
          <!-- <div>{{ carrerDeatils.CityName.text }}</div> -->
        </div>

        <!--Event Date-->
        <div class="d-flex mb-3 justify-content-center">
          <div class="col-xl-3 col-md-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[11].title }}
          </div>
          <input
            name="Event Date"
            v-validate="'required'"
            type="date"
            v-model="carrerDeatils.eventDate"
            :min="moment().format('YYYY-MM-DD')"
            id="eventDateID"
            placeholder="DD/MM/YYYY"
            class="carrer_input"
          />
        </div>

        <!--Event Time-->

        <div class="d-flex mb-3 justify-content-center">
          <div class="col-xl-3 col-md-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[12].title }}
          </div>
          <input
            name="Event Time"
            v-validate="'required'"
            type="time"
            min="01:00"
            max="23:00"
            v-model="carrerDeatils.eventTime"
            placeholder="DD/MM/YYYY"
            class="carrer_input"
          />
        </div>

        <!---Upload cv-->
        <!-- <div class="d-flex mb-3 d-none">
          <div class="col-6 align-items-center font-bold">
            {{ allLanguageData.Carrer[7].title }}
            <p
              class="mb-0 errorMessage"
              :class="langName == 'ar' ? 'text-right' : 'text-left'"
              style="color:red"
              >({{ allLanguageData.OnlyPdf }})</p
            >
          </div> -->

        <!-- <b-input-group>
            <b-form-file
              id="form-image"
              :disabled="busy"
              accept="image/pdf"
            ></b-form-file>
          </b-input-group> -->
        <!-- <div
            class="col-md-4 col-6 d-flex flex-column px-0"
            :class="langName == 'ar' ? 'pl-md-2' : 'pr-md-2'"
          >
            <div class="text-center mb-2">
              <input
                :id="
                  langName == 'ar' ? 'uploadFilecarrer_ar' : 'uploadFilecarrer'
                "
                :placeholder="FileName"
                disabled="disabled"
              />
            </div>

            <label class="custom-file-upload-carrer btn">
              <input
                type="file"
                id="resume"
                v-on:change="uploadImage($event)"
                accept="application/pdf,.doc,.docx,application/msword"
                class="d-none"
                name="resume"
              />
              {{ allLanguageData.Carrer[8].title }}
            </label>
          </div>
        </div> -->

        <!-- <div>
            {{ FileName }}
          </div> -->
        <!--Tell us -->
        <!-- <div class="d-flex mb-3">
          <div class="col-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[9].title }}
          </div>

          <textarea
            v-model="carrerDeatils.Message"
            type="text"
            cols="20"
            rows="4"
            v-on:input="check"
            class="carrer_input"
          >
          </textarea> -->
        <!-- <p>
            {{ instruction }}
          </p> -->
        <!-- </div> -->
        <!-- Type of Events -->
        <div class="d-flex mb-3 justify-content-center">
          <div class="col-xl-3 col-md-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[13].title }}
          </div>

          <multiselect
            v-model="selectedEvents"
            :options="localizedEventOptions"
            label="text"
            track-by="value"
            class="carrer_input"
            :select-label="''"
            :deselect-label="''"
            :placeholder="
              langName === 'ar' ? 'نوع الحفل ' : 'Select Event Type'
            "
            :selectedLabel="''"
            :class="{ 'multiselect-arabic': langName === 'ar' }"
            :style="{
              textAlign: langName === 'ar' ? 'right' : 'left',
            }"
            required
          >
          </multiselect>
        </div>
        <!-- type of Experience -->
        <div class="d-flex mb-3 justify-content-center">
          <div class="col-xl-3 col-md-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[14].title }}
          </div>

          <multiselect
            v-model="selectedExp"
            :options="localizedExperienceOptions"
            label="text"
            track-by="value"
            class="carrer_input"
            :select-label="''"
            :deselect-label="''"
            :placeholder="
              langName === 'ar' ? 'نوع التجربة ' : 'Select Experience Type'
            "
            :selectedLabel="''"
            :class="{ 'multiselect-arabic': langName === 'ar' }"
            :style="{
              textAlign: langName === 'ar' ? 'right' : 'left',
            }"
            required
          >
          </multiselect>
        </div>

        <!-- No of Input -->

        <div class="d-flex mb-3 justify-content-center">
          <div class="col-xl-3 col-md-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[15].title }}
          </div>

          <b-form-input
            v-model="carrerDeatils.NOofPersons"
            type="number"
            class="carrer_input"
            required
          />
        </div>
        <!-- decorations -->
        <div class="d-flex mb-3 justify-content-center">
          <div class="col-xl-3 col-md-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[16].title }}
          </div>

          <multiselect
            v-model="selectedDecoration"
            :options="localizedDecorOptions"
            label="text"
            track-by="value"
            class="carrer_input"
            :select-label="''"
            :deselect-label="''"
            :placeholder="
              langName === 'ar'
                ? 'الديكور مقدم من '
                : 'Select Decoration provided by'
            "
            :selectedLabel="''"
            :class="{ 'multiselect-arabic': langName === 'ar' }"
            :style="{
              textAlign: langName === 'ar' ? 'right' : 'left',
            }"
            required
          >
          </multiselect>
        </div>

        <!-- Do you need animation? -->

        <div class="d-flex mb-3 justify-content-center">
          <div class="col-xl-3 col-md-6 d-flex align-items-center font-bold">
            {{ allLanguageData.Carrer[17].title }}
          </div>

          <multiselect
            v-model="selectedAni"
            :options="localizedYesNoOptions"
            label="text"
            track-by="value"
            class="carrer_input"
            :select-label="''"
            :deselect-label="''"
            :placeholder="
              langName === 'ar' ? ' هل تحتاج لترفيه' : 'Do you need animation?'
            "
            :selectedLabel="''"
            :class="{ 'multiselect-arabic': langName === 'ar' }"
            :style="{
              textAlign: langName === 'ar' ? 'right' : 'left',
            }"
            required
          >
          </multiselect>
        </div>
        <div :style="{ marginRight: langName === 'ar' ? '22px' : '' }">
          <div class="main-heading">
            <div>
              <hr class="primary-line" />
            </div>
            <div class="title">{{ allLanguageData.ThingstoknowTitle }}</div>
          </div>
          <ul
            :style="{ textAlign: langName === 'ar' ? 'right' : 'left' }"
            class="private_listing"
          >
            <li>{{ allLanguageData.Thingstoknow[0].t1 }}</li>
            <li>{{ allLanguageData.Thingstoknow[1].t2 }}</li>
            <li>{{ allLanguageData.Thingstoknow[2].t3 }}</li>
          </ul>
        </div>
        <div class="my-2 errorMessage text-center" style="color: red">
          {{ carrerDeatils.errorMessage }}
        </div>
        <div class="text-center d-flex">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <b-button
              v-on:click="onFinalSubmit()"
              class="submit-btn mt-md-3 my-3"
            >
              {{ allLanguageData.ContactUsModal.Btn }}
            </b-button>
          </div>
        </div>

        <!--For More Information-->
        <!-- <div class="col-12 d-block">
          <h5 class="font-bold">
            {{ allLanguageData.for_moreinfo }}
          </h5>
          <p>
            jobs@empirecinemas.com.sa /
            <a href="tel:+966 114646111">+966 114646111</a>
          </p>
        </div> -->

        <!--Succesful Message Modal-->
        <b-modal
          id="modal_1"
          ref="modal_1"
          title="BootstrapVue"
          hide-header
          hide-footer
        >
          <div
            class="d-flex justify-content-center flex-column align-items-center"
          >
            <p class="my-4 text-center font-bold">
              {{ allLanguageData.Thanks_for_sub }}
            </p>
            <img
              src="@/assets/img/svg/done_career.svg"
              class="custom-width-svg"
            />
          </div>
        </b-modal>
      </div>
    </form>

    <!---Form Section End-->
  </div>
</template>
<script>
import QuickBook from "@/components/partials/newQuickBook.vue";
import { makeRequest } from "@/helper/internet.js";
import { LanguageService } from "@/services/storage.service";
import { makeRequestBrij } from "../../../helper/internet";
import axios from "axios";
import moment from "moment";
import { event } from "jquery";
export default {
  components: {
    QuickBook,
  },
  mounted() {
    let language = LanguageService.getLanguage();
    if (!language) {
      this.LanguageID = 2;
    } else {
      this.LanguageID = language.lang_id;
    }
    // this.handleResize();
    let lang = LanguageService.getLanguage();
    if (lang == null) {
      this.langName = "eng";
    } else {
      this.langName = lang["lang"];
    }
  },
  data() {
    return {
      country_list_array: [],
      cinema_array: [],
      translatedBranchName: [],
      // URL_BASE: URL_BASE,
      URL_BASE: "https://api-empire.brij.tech",
      menuBanners: [],
      menuDataArray: [],
      cityOptions: [],
      bannerSlider: {
        arrows: false,
        dots: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 2000,
      },
      carrerDeatils: {
        fullName: "",
        Email: "",
        // fullmobnumber: "",
        Mobile: "",
        // Message: "",
        CountryID: null,
        CityID: null,
        CityName: "",
        errorMessage: "",
        status: "",
        status1: "",
        status2: "",
        eventDate: "",
        eventTime: "",
        NOofPersons: null,
      },
      selectedEvents: {},
      selectedExp: {},
      selectedDecoration: {},
      selectedAni: {},
      translatedStates: [],
      englishEventOptions: [
        { text: "Birthday", value: "birthday" },
        { text: "Anniversary", value: "anniversary" },
        { text: "Corporate", value: "corporate" },
        { text: "School", value: "school" },
        { text: "Other", value: "other" },
      ],
      arabicEventOptions: [
        { text: "عيد ميلاد", value: "birthday" },
        { text: "ذكرى سنوية ", value: "anniversary" },
        { text: "حفلات شركات", value: "corporate" },
        { text: "مدارس", value: "school" },
        { text: "أخرى", value: "other" },
      ],
      ExperienceOptionsEN: [
        { text: "Minis", value: "Minis" },
        { text: "Premiere", value: "Premiere" },
        { text: "IMAX", value: "IMAX" },
        { text: "Dolby Atmos", value: "Dolby Atmos" },
        { text: "Screen X", value: "Screen X" },
        { text: "Sphera with Flexsound ", value: "Sphera with Flexsound " },
        { text: "4DX ", value: "4DX " },
      ],
      ExperienceOptionsAR: [
        { text: "مينيز", value: "Minis" },
        { text: "بريمير", value: "Premiere" },
        { text: "آيماكس", value: "IMAX" },
        { text: "دولبي اتموس ", value: "Dolby Atmos" },
        { text: "سكرين أكس", value: "Screen X" },
        { text: "سفير ا فليكس ساوند ", value: "Sphera with Flexsound" },
        { text: "فور دي اكس", value: "4DX " },
      ],
      decorationOptionEN: [
        { text: "Empire", value: "Empire" },
        { text: "Customer", value: "Customer" },
      ],
      decorationOptionAR: [
        { text: "امباير", value: "Empire" },
        { text: "العميل ", value: "Customer" },
      ],
      animationOptionEN: [
        { text: "Yes", value: "Yes" },
        { text: "No", value: "No" },
      ],
      animationOptionAR: [
        { text: "نعم", value: "Yes" },
        { text: "كلا", value: "No" },
      ],
      translations: {
        countrySelectorLabel: "رمز البلد",
        countrySelectorError: "اختر بلداً",
        phoneNumberLabel: "رقم الهاتف",
        example: "مثال:",
      },
      foodSlider1: {
        arrows: true,
        dots: false,
        infinite: true,
        slidesToScroll: 3,
        slidesToShow: 6,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              adaptiveHeight: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              adaptiveHeight: true,
              arrows: false,
            },
          },
        ],
      },
      pagesList: [],
    };
  },
  beforeCreate: function() {
    document.body.className = "light-section";
  },
  beforeMount() {
    // this.fetchCities();
    this.getBrijCinemas();
    this.getListOfPages();
    // const today = new Date().toISOString().split("T")[0];
    // console.log(today, "todayyyyyyyy");
    // // Set the min attribute of the input to today's date
    // document.getElementById("eventDateID").setAttribute("min", today);
    //  const { movieId, cat_id } = this.$route.params;
    // if (movieId && cat_id) {
    //   // this.MovieID = movieId.toString().split(",");
    //   // this.CategoryID = cat_id;

    // this.getShowTimeBanners();
    // } else {
    //   console.log(this.$route.params, "jitu");
    //   // this.$router.go(-1);
    // }
  },
  computed: {
    localizedEventOptions() {
      return this.langName === "ar"
        ? this.arabicEventOptions
        : this.englishEventOptions;
    },
    localizedExperienceOptions() {
      return this.langName === "ar"
        ? this.ExperienceOptionsAR
        : this.ExperienceOptionsEN;
    },
    localizedDecorOptions() {
      return this.langName === "ar"
        ? this.decorationOptionAR
        : this.decorationOptionEN;
    },
    localizedYesNoOptions() {
      return this.langName === "ar"
        ? this.animationOptionAR
        : this.animationOptionEN;
    },
    computedTranslations() {
      return this.langName === "ar" ? this.translations : {};
    },
  },
  methods: {
    moment,
    onUpdate(payload) {
      this.results = payload;
    },
    // getShowTimeBanners() {
    //   this.showLoading();
    //   let payload = {
    //     PageName: "foodMenu",
    //   };

    //   makeRequest("/PageData/", "POST", null, payload)
    //     .then((response) => {
    //       const { error, res } = response; // console.log("Show details", res);

    //       console.log(res.data, "uu");
    //       if (res.data.hasOwnProperty("banner") && res.data.banner.length > 0) {
    //         this.menuBanners = res.data.banner;
    //       }

    //       if (res.data.hasOwnProperty("data") && res.data.data.length > 0) {
    //         this.menuDataArray = res.data.data;
    //       }

    //       // if (res.data.hasOwnProperty("data") && res.data.data.length > 0) {
    //       //   this.header = res.data.data[0].header;
    //       //   this.header1 = res.data.data[0].header1;
    //       //   this.description = res.data.data[0].description;
    //       // }

    //       this.hideLoading();
    //       console.log("jitu");
    //     })
    //     .catch((error) => {
    //       this.hideLoading();
    //       console.log("Error", error);
    //     });
    // },

    translateToArabic(stateName) {
      const translations = {
        Arar: "عرعر",
        YANBU: "ينبع",
        TAIF: "الطائف",
        QATIF: "القطيف",
        JUBAIL: "الجبيل",
        JOUF: "الجوف",
        JEDDAH: "جدة",
        DHAHRAN: "الظهران",
        DAMMAM: "الدمام",
        "AL AHSA": "الأحساء",
        ABHA: "أبها",
        RIYADH: "الرياض",
        MADINAH: "المدينة المنورة",
        TABOUK: "تبوك",
        QASSEM: "القصيم",
        NAJRAN: "نجران",
        MAKKAH: "مكة",
        JAZAN: "جازان",
        Hail: "حائل",
        "AL KHOBAR": "الخبر",
      };
      return translations[stateName] || stateName;
    },

    fetchCities() {
      var config = {
        method: "get",
        url: `${
          this.BrijBaseUrl
        }/api/get_ms_states_list?state_is_active=Y&country_id=191`,
      };
      axios(config)
        .then((result) => {
          const { data } = result;
          if (data && data.Records && data.Records.length) {
            this.cityOptions = data.Records.map((val) => ({
              state_id: val.state_id || "",
              state_name: val.state_name || "",
              state_name_ar:
                this.langName === "ar"
                  ? this.translateToArabic(val.state_name)
                  : val.state_name,
              cmp: String(val.state_name)
                .trim()
                .toUpperCase(),
            }));

            this.translatedStates = this.cityOptions.sort((a, b) =>
              a.cmp.localeCompare(b.cmp)
            );
            // console.log("Translated States:", this.translatedStates);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getBrijCinemas: function() {
      this.showLoading();
      makeRequestBrij("/api/external/cinemas", "POST", null, {})
        .then((response) => {
          const { error, res } = response;
          if (res.data.status) {
            let { data } = res;

            this.country_list_array = data.country_list_array;

            this.cinema_array = data.Records;
            // this.cinema_array.map((elem) => {
            //   return elem.translation_data[0].map((data) => {
            //     return this.translatedBranchName.push(data[0].cinema_name);
            //   });
            // });

            this.translatedBranchName = this.cinema_array.map((cinema) => ({
              ["cinema_name"]: cinema.translation_data[0].cinema_name,
              ["cinema_id"]: cinema.cinema_id,
            }));
            if (!localStorage.getItem("brij_country")) {
              if (window.location.host == "ksa.empirecinemas.com") {
                console.log("fsdfsdf");
                let country_saudi = this.country_list_array.filter((z) => {
                  return z.country_id == 191;
                });
                console.log("fsfs", country_saudi);

                // if (country_saudi.length) {
                //   country_saudi.map(country => {
                //     this.onSelectCountry(
                //       country.country_name,
                //       (
                //         this.countryData[country.country_name] ||
                //         this.countryData.Other
                //       ).CountryID,
                //       'eng',
                //       2,
                //       country,
                //       { brij_lang_id: 1, iso_2: 'en' }
                //     )
                //   })
                // }
              }
            }
          }

          this.hideLoading();
        })
        .catch((error) => {
          this.hideLoading();
          console.log("Error", error);
        });
    },
    getListOfPages() {
      const pagesFunction = async () => {
        try {
          let payload = {
            mpm_name: "privateBooking",
            mpm_lang_id: this.getCurrentLang().brij_lang_id,
          };
          let response = await makeRequestBrij(
            `/api/admin/list-of-pages?mpm_name=${
              payload.mpm_name ? payload.mpm_name : ""
            }&mpm_lang_id=${payload.mpm_lang_id ? payload.mpm_lang_id : ""}`,
            "GET",
            null,
            null
          );
          const { error, res } = response;

          if (res.data.status) {
            let { data } = res;
            let records = data.Records;
            let newRecords = [];
            records.map((x, index) => {
              let get_index = newRecords.findIndex((y) => {
                return y.main_name == x.mpm_name;
              });
              console.log({ get_index });
              if (get_index < 0) {
                let obj = {
                  mpm_id: x.mpm_id,
                  main_name: x.mpm_name,
                  lang_id: x.mpm_lang_id,
                  banner: x.mpm_banner,
                  status: x.is_active,
                  otherData: [
                    {
                      mpm_d_id: x.mpm_d_id,
                      main_name: x.mpm_d_main_name,
                      header_name: x.mpm_d_header_name,
                      description: x.mpm_d_description,
                      images: x.mpm_d_images,
                      cover_image: x.mpm_d_cover_image,
                      o_status: x.mpm_d_is_active,
                    },
                  ],
                };
                newRecords.push(obj);
              } else {
                let obj = {
                  mpm_d_id: x.mpm_d_id,
                  main_name: x.mpm_d_main_name,
                  header_name: x.mpm_d_header_name,
                  description: x.mpm_d_description,
                  images: x.mpm_d_images,
                  cover_image: x.mpm_d_cover_image,
                  o_status: x.mpm_d_is_active,
                };
                newRecords[get_index].otherData.push(obj);
              }
            });
            // console.log("newRecords", newRecords);
            this.pagesList = newRecords;
            this.menuBanners = this.getSafe(() => this.pagesList[0], {
              banner: "",
            });
          }
        } catch (error) {
          console.log("getPagesList", { error });
        }
      };
      pagesFunction();
    },

    validateForm() {
      let value = true;
      // console.log(this.results, "this.resultsthis.results");
      let careerData = this.carrerDeatils;
      const regex = /^[a-zA-Z\s]+$/;
      this.carrerDeatils.errorMessage = "";
      let MobileData = this.carrerDeatils.Mobile;
      // this.chekboxes.errorMessage = "";
      if (this.carrerDeatils.fullName == "") {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage =
              "حقل الاسم الكامل لا يمكن أن يكون فارغًا")
          : (this.carrerDeatils.errorMessage = "Full Name Cannot be Empty");
        return false;
      } else if (!regex.test(this.carrerDeatils.fullName)) {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = "حرف غير صالح في حقل الاسم")
          : (this.carrerDeatils.errorMessage =
              "Invalid Character in Name Field");
        return false;
      } else if (
        this.carrerDeatils.Email == "" ||
        /\S+@\S+\.\S+/.test(this.carrerDeatils.Email) == false
      ) {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `لا يمكن ترك حقل البريد الإلكتروني فارغًا`)
          : (this.carrerDeatils.errorMessage =
              "Email Address Cannot be Empty / Invalid Email");
        return false;
      }
      // else if (this.carrerDeatils.formatInternational == "") {
      //   this.carrerDeatils.errorMessage = "Mobile Number Cannot be Empty";
      //   return false;
      // }
      else if (
        MobileData == "" ||
        MobileData.startsWith("0") ||
        MobileData.length > 9 ||
        MobileData.length < 9
      ) {
        // alert();
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `رقم الجوال غير صالح`)
          : (this.carrerDeatils.errorMessage = "Mobile Number is Invalid");
        return false;
      } else if (this.results.isValid == false) {
        // alert();
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `رقم الجوال غير صالح`)
          : (this.carrerDeatils.errorMessage = "Mobile Number is Invalid");
        return false;
      } else if (this.carrerDeatils.CityName == "") {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `الرجاء اختيار مدينتك`)
          : (this.carrerDeatils.errorMessage = "Please Selct your city");

        return false;
      } else if (this.carrerDeatils.eventDate == "") {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `الرجاء إدخال تاريخ الحدث`)
          : (this.carrerDeatils.errorMessage = "Please Enter Event Date");

        return false;
      } else if (this.carrerDeatils.eventTime == "") {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `الرجاء إدخال وقت الحدث`)
          : (this.carrerDeatils.errorMessage = "Please Enter Event Time");

        return false;
      } else if (this.selectedEvents && !this.selectedEvents.value) {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `الرجاء اختيار الحدث`)
          : (this.carrerDeatils.errorMessage = "Please Select an Event");
        return false;
      } else if (this.selectedExp && !this.selectedExp.value) {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `الرجاء اختيار التجربة`)
          : (this.carrerDeatils.errorMessage = "Please Select an Experience");
        return false;
      } else if (
        !this.carrerDeatils.NOofPersons ||
        careerData.NOofPersons.startsWith("0") ||
        careerData.NOofPersons.includes("-") ||
        careerData.NOofPersons.length > 3
      ) {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `الرجاء إدخال عدد الأشخاص`)
          : (this.carrerDeatils.errorMessage =
              "Please Enter Number Of Persons");

        return false;
      } else if (this.selectedDecoration && !this.selectedDecoration.value) {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `الرجاء اختيار الديكور`)
          : (this.carrerDeatils.errorMessage = "Please Select the Decoration");

        return false;
      } else if (this.selectedAni && !this.selectedAni.value) {
        this.langName == "ar"
          ? (this.carrerDeatils.errorMessage = `الرجاء تحديد الرسوم المتحركة`)
          : (this.carrerDeatils.errorMessage = "Please Select an Animation");

        return false;
      } else {
        return true;
      }
    },
    onFinalSubmit(event) {
      if (this.validateForm()) {
        let cityData = this.carrerDeatils.CityName;
        let formattedEventDate = moment(this.carrerDeatils.eventDate).format(
          "DD-MM-YYYY"
        );
        let payload = {
          name: this.carrerDeatils.fullName || "",
          email: this.carrerDeatils.Email,
          cityName: cityData.cinema_name,
          contact_no:
            "+" +
            this.results.countryCallingCode +
            "" +
            this.carrerDeatils.Mobile,
          eventDate: formattedEventDate,
          eventTime: moment(this.carrerDeatils.eventTime, "HH:mm").format(
            "h:mm A"
          ),
          typeofEvent: this.selectedEvents.text,
          experienceType: this.selectedExp.text,
          NOofPersons: this.carrerDeatils.NOofPersons,
          decorationProvidedBy: this.selectedDecoration.text,
          animation: this.selectedAni.text,
        };
        let ProfileData = JSON.parse(localStorage.getItem("profile_detail"));

        if (ProfileData && Object.keys(ProfileData).length > 0) {
          let netcoreUserDataPayload = {
            FULL_NAME: ProfileData.FirstName + "" + ProfileData.LastName,
            email: ProfileData.Email,
            "pk^mobile": Number(ProfileData.Mobile),
          };

          smartech("contact", 12, netcoreUserDataPayload);

          smartech(
            "identify",
            ProfileData && ProfileData.Mobile != "" ? Number(ProfileData) : ""
          );
        }

        let netCorePrivateBooking = {
          branch: cityData.cinema_name,
          event_date: moment(this.carrerDeatils.eventDate).format(
            "YYYY-MM-DD HH:MM:SS"
          ),
          event_time: moment(this.carrerDeatils.eventTime, "HH:mm").format(
            "h:mm A"
          ),
          event_type: this.selectedEvents.text,
          experience_type: this.selectedExp.text,
          no_of_person: Number(this.carrerDeatils.NOofPersons),
          decoration_by: this.selectedDecoration.text,
          animation_required: this.selectedAni.text,
        };
        smartech("dispatch", "Private Booking", netCorePrivateBooking);

        makeRequestBrij(
          "/api/external/sendMailPrivateBooking",
          "POST",
          null,
          payload
        )
          .then((response) => {
            const { error, res } = response;
            this.hideLoading();
            if (!error) {
              if (res.data.status) {
                // this.contactUsDeatils.errorMessage = res.data.Message;
                this.carrerDeatils.fullName = "";
                this.carrerDeatils.Mobile = "";
                this.carrerDeatils.Email = "";
                this.carrerDeatils.CityName = "";
                this.carrerDeatils.eventDate = "";
                this.carrerDeatils.eventTime = "";
                this.selectedEvents = {};
                this.selectedExp = {};
                this.carrerDeatils.NOofPersons = null;
                this.selectedDecoration = {};
                this.selectedAni = {};
                // this.carrerDeatils.Message = "";

                this.SuccessMessage = res.data.message;
                setTimeout(() => {
                  this.$refs.modal_1.show();
                }, 1000);
                event.target.reset();
              } else {
                this.carrerDeatils.errorMessage = res.data.message;
              }
            }
          })
          .catch((error) => {
            console.log("Error", error);
            this.carrerDeatils.errorMessage = "";
          });
      }
    },
  },
};
</script>
<style>
.offer-imgs .offer-img {
  border: 1px solid #b40a28;
  width: 95%;
  cursor: pointer;
}
.custom-width-svg {
  width: 10%;
}

@media (max-width: 767px) {
  /* .offer-imgs .offer-img {
    width: 100%;
  } */
}
.offer-imgs .slick-track {
  margin-left: 0 !important;
}
.input-tel__input::placeholder {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/offer/privatebooking.vue